module.exports = __webpack_public_path__ + "img/7d.3d974178.png";